import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground text-background py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <span className="text-white font-heading font-bold text-lg">CK</span>
              </div>
              <span className="font-heading font-semibold text-lg">Christ Kingdom</span>
            </div>
            <p className="text-background/70 text-sm leading-relaxed">
              A global marketplace connecting Christians worldwide to buy and sell faith-inspired goods and services.
            </p>
          </div>

          {/* Shop */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Shop</h4>
            <ul className="space-y-2 text-sm text-background/70">
              <li><Link to="/products" className="hover:text-background transition-colors">All Products</Link></li>
              <li><Link to="/products?category=Jewelry%20%26%20Accessories" className="hover:text-background transition-colors">Jewelry</Link></li>
              <li><Link to="/products?category=Home%20%26%20Decor" className="hover:text-background transition-colors">Home & Decor</Link></li>
              <li><Link to="/products?category=Books%20%26%20Media" className="hover:text-background transition-colors">Books & Media</Link></li>
              <li><Link to="/products?category=Apparel" className="hover:text-background transition-colors">Apparel</Link></li>
              <li><Link to="/install" className="hover:text-background transition-colors" data-testid="footer-install-link">Get the App</Link></li>
            </ul>
          </div>

          {/* Sell */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Sell</h4>
            <ul className="space-y-2 text-sm text-background/70">
              <li><Link to="/register" className="hover:text-background transition-colors">Become a Vendor</Link></li>
              <li><Link to="/vendor" className="hover:text-background transition-colors">Vendor Dashboard</Link></li>
              <li><Link to="/about" className="hover:text-background transition-colors" data-testid="footer-about-link">About Us</Link></li>
              <li><Link to="/oil-and-gas" className="hover:text-background transition-colors" data-testid="footer-oilgas-link">B2B Oil &amp; Gas</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm text-background/70">
              <li>
                <a
                  href="mailto:support@christkingdomglobalmarketplace.com"
                  className="hover:text-background transition-colors break-all"
                  data-testid="footer-support-email"
                >
                  support@christkingdomglobalmarketplace.com
                </a>
              </li>
              <li><Link to="/refund-policy" className="hover:text-background transition-colors" data-testid="footer-refund-link">Returns & Refunds</Link></li>
              <li><Link to="/terms" className="hover:text-background transition-colors" data-testid="footer-terms-link">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-background transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              <li><Link to="/vendor/covenant" className="hover:text-background transition-colors" data-testid="footer-covenant-link">Partnership Covenant</Link></li>
              <li><Link to="/vendor/apply" className="hover:text-background transition-colors" data-testid="footer-apply-link">Become a Vendor</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-background/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-background/70">
            © 2026 Christ Kingdom Global Marketplace. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-background/70">
            <Link to="/privacy" className="hover:text-background transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-background transition-colors">Terms</Link>
            <Link to="/refund-policy" className="hover:text-background transition-colors">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
